import React from 'react';
import { connect } from 'react-redux';
import ListFilter from '@bit/knotchinc.web-react-components.list-filter';
import Input from '@bit/knotchinc.web-react-components.input';
import { capitalizeString } from 'helpers/Utils.js';
import { debounce } from 'lodash';
import {
  fetchComparedBrands,
  fetchComparedPublishers,
  REMOVE_ENTITY_INSIGHTS,
  addEntityInsights,
} from 'components/Pages/Entity/actions';
import { SET_PUBLISHERS_FILTER, SET_BRANDS_FILTER } from 'components/Global/Filters/actions.js';
import { SlideToggle } from 'components/Global/Buttons';
import Mixpanel from 'helpers/Mixpanel.js';
import CompareEntityFilterItem from './CompareEntityFilterItem.jsx';
import {
  CompareToggleWrapper,
  CompareToggleTopSection,
  CompareToggleTitle,
  StyledComparePrompt,
  StyledCompareEntityItemContainer,
  StyledCompareEntityItem,
  StyledCompareEntityIcon,
  RemoveCompareEntity,
  CompareToggleListSection,
  SelectedCompareEntitiesContainer,
} from './styled.js';

class CompareToggle extends React.Component {
  constructor() {
    super();
    this.state = {
      comparing: false,
      searchQuery: '',
      selected: [],
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.debouncedSearch = debounce(value => this.fetchWithSearchQuery(value), 500);
  }

  fetchWithSearchQuery(value) {
    const { setComparedSearch } = this.props;
    this.setState({ searchQuery: value });
    setComparedSearch(value);
  }

  handleToggle() {
    const { selected } = this.state;

    if (selected.length) {
      selected.forEach(entity => this.handleRemoveEntity(entity));
    }

    this.setState(prevState => ({ comparing: !prevState.comparing }));
    Mixpanel.track(`clicked compare toggle`);
  }

  handleAddEntity(item) {
    const { addEntity, comparedList } = this.props;
    const id = item.public_id;

    if (addEntity && id && comparedList.data) {
      addEntity(id);
      const brandData = comparedList.data.find(entity => entity.public_id === id);
      this.setState(prevState => ({ selected: [...prevState.selected, brandData] }));
    }
  }

  handleRemoveEntity(item) {
    const { removeEntity } = this.props;
    const id = item.public_id;

    if (removeEntity && id) {
      removeEntity(id);
      this.setState(prevState => ({
        selected: prevState.selected.filter(entity => entity.public_id !== id),
      }));
    }
  }

  renderCompareList() {
    const { entityType, getComparedList, userEntity, comparedList, entityId } = this.props;
    const { selected } = this.state;
    const currentEntityId = userEntity && userEntity.public_id;
    const currentAction = entityType === 'brand' ? SET_BRANDS_FILTER : SET_PUBLISHERS_FILTER;

    return (
      <CompareToggleListSection>
        {selected.length > 0 ? (
          <SelectedCompareEntitiesContainer>
            <StyledComparePrompt showBorder>Against</StyledComparePrompt>
            {selected.map((entity) => (
              <StyledCompareEntityItemContainer key={`comparing-entity-${entity.name}`}>
                <StyledCompareEntityIcon logo_url={entity.logo_url} />
                <StyledCompareEntityItem>{entity.name}</StyledCompareEntityItem>
                <RemoveCompareEntity onClick={() => this.handleRemoveEntity(entity)} />
              </StyledCompareEntityItemContainer>
            ))}
          </SelectedCompareEntitiesContainer>
        ) : null}
        {selected.length < 4 ? (
          <React.Fragment>
            <StyledComparePrompt>Please choose a {entityType === 'brand' ? 'brand' : 'publisher' } to compare against.</StyledComparePrompt>
            <Input hideErrorText placeholder={`Search ${capitalizeString(entityType)}s`} callback={(value) => this.debouncedSearch(value)} />
            <ListFilter
              fetch={(clear) => getComparedList(clear)}
              listStore={comparedList}
              filterAction={currentAction}
              filterCondition={item => item.public_id !== entityId}
              searchBy="name"
            >
              <CompareEntityFilterItem
                showLogo
                selectedItems={selected}
                onClick={(item) => this.handleAddEntity(item)}
                selectedKey="public_id"
                currentEntityId={currentEntityId}
              />
            </ListFilter>
          </React.Fragment>
        ) : null}
      </CompareToggleListSection>
    );
  }

  render() {
    const { comparing } = this.state;
    return (
      <CompareToggleWrapper comparing={comparing}>
        <CompareToggleTopSection>
          <CompareToggleTitle>Compare</CompareToggleTitle>
          <SlideToggle type="compare" toggled={comparing} toggleHandler={() => this.handleToggle()} />
        </CompareToggleTopSection>
        {comparing && this.renderCompareList()}
      </CompareToggleWrapper>
    );
  }
}

const mapStateToProps = ({
  BrandsList: { brandsList },
  PublishersList: { publishersList },
  Account: { userEntity },
}, { entityType }) => ({
  comparedList: entityType === 'brand' ? brandsList : publishersList,
  userEntity,
});

const mapDispatchToProps = (dispatch, { entityType, entityId }) => ({
  addEntity: (addedEntityId) => dispatch(addEntityInsights(addedEntityId, entityType)),
  removeEntity: removedEntityId => dispatch({ type: REMOVE_ENTITY_INSIGHTS, entityId: removedEntityId }),
  getComparedList: (clear) => entityType === 'brand' ?
    dispatch(fetchComparedBrands(clear, entityId)) :
    dispatch(fetchComparedPublishers(clear, entityId)),
  setComparedSearch: (searchQuery) => {
    const filters = { searchQuery, searchBy: searchQuery ? 'name' : '', pageNum: 1 };
    entityType === 'brand' ?
      dispatch({ type: SET_BRANDS_FILTER, filters }) :
      dispatch({ type: SET_PUBLISHERS_FILTER, filters });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompareToggle);
